import React from 'react';
import { DateTime } from 'luxon';
import RightMediaSection from '../../_common/RightMediaSection';
import MiddleDot from '../../_common/MiddleDot';

export default function NotStarted(props) {
  const { evaluation, onClickView, onClickEdit } = props;

  return (
    <RightMediaSection
      title={(
        <div className="text-cs-orange-500">
          Start now!
        </div>
      )}
      subtitle={(
        <div className="flex space-x-1">
          <span>
            Evaluation created {DateTime.fromISO(evaluation.data.createdAt).toRelative()}
          </span>
          {onClickEdit && (
            <>
              <span>
                <MiddleDot/>
              </span>
              <span className="text-blue-500 hover:text-blue-300 cursor-pointer" onClick={onClickEdit}>
                Edit
              </span>
            </>
          )}
          {onClickView && (
            <>
              <span>
                <MiddleDot/>
              </span>
              <span className="text-blue-500 hover:text-blue-300 cursor-pointer" onClick={onClickView}>
                View
              </span>
            </>
          )}
        </div>
      )}
    />
  );
};
